'use strict';
import {Dialog} from './dialog.js';
export class DialogAboutme extends Dialog {
	
	constructor(component_key) {
		super(component_key);
	}
	init() {
		super.init();
		this.add_events();
	}
	get track() {
	
	}
	load() {
		super.load();
		return this;
	}
	add_events() {
		super.add_events();
	}
	on_show() {
		jQuery('html').addClass('js-no_scroll');
		setTimeout(() => {
			jQuery(`.js-${this.id}_position`).addClass('js-active');
		}, 50);
	}
	
	on_close() {
		jQuery(`.js-${this.id}_position`).removeClass('js-active');
		jQuery('html').removeClass('js-no_scroll');
	}
	
}
